import React from 'react';
import styles from '../../styles/EventScribeSpinner.module.css';
 
import {
  INIT_APPLICATION_MESSAGE,
  
} from "../../constants";
const EventScribeSpinner = ({ message = INIT_APPLICATION_MESSAGE, logovisible = false, background = '' }) => {
    const inlineStyle = background ? { backgroundColor: background } : {};
    
    return (
        <div className={styles.spinnerOverlay} style={inlineStyle}>
            {logovisible && (   
                <div className={styles.spinnerLogoBox}>
                    <img src="/logo.svg" alt="eventscribe Logo" className={styles.logo} />
                </div>
            )}
            <div className={styles.spinnerDots}>
                <div className={styles.spinnerDot}></div>
                <div className={styles.spinnerDot}></div>
                <div className={styles.spinnerDot}></div>
            </div>
            <div className={styles.spinnerMessageBox}>
                <p className={styles.spinnerMessage}>{message}</p>
            </div>
        </div>
    );
};

export default EventScribeSpinner;
